import React from 'react';
import { markupHelpers } from '../../helpers';
import * as Date from '../dates/dateHelpers';
import * as Buttons from '../ui/buttons';

export const EducationItem = props => {
	const {
		institution,
		qualification,
		qualification_date,
		description,
		buttonHandlers,
		guestMode,
	} = props;
	const convertedInstitution = markupHelpers.escapeHtmlHelper(institution),
		convertedQualification = markupHelpers.escapeHtmlHelper(qualification),
		convertedDescription = markupHelpers.escapeHtmlHelper(description);

	return (
		<div className="item-education">
			{/*show when not in guestMode*/}
			{!guestMode && (
				<div className="item-display-mode">
					<Buttons.EditButton {...buttonHandlers} />
				</div>
			)}
			{/*/////////*/}
			<div className="row">
				<div className="col-4 col-lg-3 new-profile-label">Institution</div>
				<div className="col-8 col-lg-9 new-profile-info item-header">
					<span className="width-reducer">{convertedInstitution}</span>
				</div>
			</div>
			<div className="row">
				<div className="col-4 col-lg-3 new-profile-label">Qualification</div>
				<div className="col-8 col-lg-9 new-profile-info">
					<span className="width-reducer">{convertedQualification}</span>
				</div>
			</div>
			<div className="row">
				<div className="col-4 col-lg-3 new-profile-label">Dates</div>
				<div className="col-8 col-lg-9 new-profile-info">
					{Date.formatEndDate(qualification_date)}
				</div>
			</div>
			<div className="row">
				<div className="col-4 col-lg-3 new-profile-label">Description</div>
				{!description ||
				description === null ||
				description === 'null' ? null : (
					<div className="col-8 col-lg-9 new-profile-info editor">
						{<p dangerouslySetInnerHTML={{ __html: convertedDescription }} />}
					</div>
				)}
			</div>
		</div>
	);
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/EducationItem.js